module.exports = __webpack_public_path__ + "img/65.a210574e.jpg";